export const MuiCheckbox = {
  defaultProps: {
    color: 'secondary'
  }
}
